import { tryParse } from '@/utils/try-parse'
import axios from 'axios'

const token = sessionStorage.getItem('pitstopCoreToken')
const user = sessionStorage.getItem('user')
const profile = sessionStorage.getItem('profile')
// const environments = sessionStorage.getItem('environments')
const tfa = sessionStorage.getItem('tfa')
const features = sessionStorage.getItem('features')
const apiSpecUrl = sessionStorage.getItem('apiSpecUrl')


const initialState = {
	profile: profile ? tryParse(profile) : null,
	user: user ? tryParse(user) : { name: '', type: '' },
	loggedIn: token ? true : false,
	token: token ?? null,
	// environments: tryParse(environments) ?? null,
	tfa: tfa ?? null,
	features: tryParse(features),
	apiSpecUrl: apiSpecUrl || null
}

if (token) {
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

function auth(state = initialState, action) {

	switch (action.type) {

		case 'auth/login': {
			return {
				...state,
				profile: action.profile,
				loggedIn: true,
				token: action.payload.token,
				user: action.payload.user,
				// environments: action.environments,
				tfa: action.tfa,
				features: action.features,
				apiSpecUrl: action.apiSpecUrl,
			}
		}

		case 'auth/logout': {
			return {
				...state,
				profile: null,
				loggedIn: false,
				user: null,
				token: null,
				// environments: null,
				tfa: null,
				features: null,
				apiSpecUrl: null,
			}
		}

		default: {
			return state
		}
	}
}

export default auth
